import React from 'react';
import styles from './Profile.module.css';

type ProfileProps = {
  name: string;
  description: string;
};

const Profile: React.FC<ProfileProps> = ({ name, description }) => {
  return (
    <div className={styles.profileCard}>
      <h2>{name}</h2>
      <p>{description}</p>
    </div>
  );
};

export default Profile;



